<template>
  <div v-editable="blok" class="column">
    <table v-if="blok.headline.length > 0 && blok.tableitems.length > 0" class="tg">
                <tr>
                    <th class="tg-188o" colspan="2">{{blok.headline}}</th>
                </tr>
                <component :key="blok._uid" v-for="blok in blok.tableitems" :blok="blok" :is="blok.component"></component>
            </table>
    <img v-if="blok.image.length > 0" :src="blok.image"/>
  </div>
</template>

<script>
export default {
  props: ['blok'],
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Column.vue